import { StateKey, TransferState, makeStateKey } from '@angular/core';
import { SvgLoader } from 'angular-svg-icon';
import { Observable } from 'rxjs';
import { readFile } from 'fs';
import { join, resolve, basename } from 'path';
import { parse } from 'url';

export class SvgServerLoader implements SvgLoader {
  constructor(
    private readonly iconPath: string,
    private readonly transferState: TransferState
  ) {}

  getSvg(url: string): Observable<string> {
    const parsedUrl = parse(url);
    const fileNameWithHash = basename(parsedUrl.pathname);

    // Remove content hashing (e.g., "icon.12345678.svg" becomes "icon.svg")
    const fileName = fileNameWithHash.replace(
      /^(.*)(\.[0-9a-f]{16,})(\.svg)$/i,
      '$1$3'
    );

    // Resolve the full file path to the SVG asset
    const filePath = join(this.iconPath, fileName);

    return new Observable((observer) => {
      readFile(resolve(__dirname, filePath), 'utf8', (err, svgData) => {
        if (err) {
          observer.error(err);
        } else {
          // Store the SVG content in the TransferState for later usage on the client side
          const key: StateKey<string> = makeStateKey<string>(
            'transfer-svg:' + url
          );
          this.transferState.set(key, svgData);

          observer.next(svgData);
          observer.complete();
        }
      });
    });
  }
}
